var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20.743,
    viewBox: "0 0 19 20.743",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6866",
    "data-name": "Path 6866",
    d: "M4,11.5v4a1.5,1.5,0,0,0,3,0v-4a1.5,1.5,0,0,0-3,0Zm6,0v4a1.5,1.5,0,0,0,3,0v-4a1.5,1.5,0,0,0-3,0ZM3.5,22h16a1.5,1.5,0,0,0,0-3H3.5a1.5,1.5,0,0,0,0,3ZM16,11.5v4a1.5,1.5,0,0,0,3,0v-4a1.5,1.5,0,0,0-3,0ZM10.57,1.49,2.67,5.65A1.245,1.245,0,0,0,3.25,8H19.76a1.245,1.245,0,0,0,.57-2.35l-7.9-4.16a1.976,1.976,0,0,0-1.86,0Z",
    transform: "translate(-2 -1.258)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagatIcon);
export default __webpack_public_path__ + "static/media/pagat_icon.0df348f132a666ecc12f65a687faf30b.svg";
export { ForwardRef as ReactComponent };